import { graphql, useStaticQuery } from 'gatsby'
import { getDataByLocale } from '~/hooks/utils/get-data-by-locale'

const useNotificationBarQuery = locale => {
  const data = useStaticQuery(graphql`
    {
      notificationBar_enUS: contentfulNotificationBar(
        slug: { eq: "notification-bar" }
        node_locale: { eq: "en-US" }
      ) {
        notification {
          slug
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
      referralNotification_enUS: contentfulNotification(
        slug: { eq: "referral" }
        node_locale: { eq: "en-US" }
      ) {
        slug
        description {
          childMarkdownRemark {
            html
          }
        }
      }

      notificationBar_enCA: contentfulNotificationBar(
        slug: { eq: "notification-bar" }
        node_locale: { eq: "en-CA" }
        disableFallbackNotification: { eq: false }
      ) {
        notification {
          slug
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
      referralNotification_enCA: contentfulNotification(
        slug: { eq: "referral" }
        node_locale: { eq: "en-CA" }
      ) {
        slug
        description {
          childMarkdownRemark {
            html
          }
        }
      }

      notificationBar_frCA: contentfulNotificationBar(
        slug: { eq: "notification-bar" }
        node_locale: { eq: "fr-CA" }
        disableFallbackNotification: { eq: false }
      ) {
        notification {
          slug
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
      referralNotification_frCA: contentfulNotification(
        slug: { eq: "referral" }
        node_locale: { eq: "fr-CA" }
      ) {
        slug
        description {
          childMarkdownRemark {
            html
          }
        }
      }

      notificationBar_heIL: contentfulNotificationBar(
        slug: { eq: "notification-bar" }
        node_locale: { eq: "he-IL" }
        disableFallbackNotification: { eq: false }
      ) {
        notification {
          slug
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
      referralNotification_heIL: contentfulNotification(
        slug: { eq: "referral" }
        node_locale: { eq: "he-IL" }
      ) {
        slug
        description {
          childMarkdownRemark {
            html
          }
        }
      }

      notificationBar_esMX: contentfulNotificationBar(
        slug: { eq: "notification-bar" }
        node_locale: { eq: "es-MX" }
        disableFallbackNotification: { eq: false }
      ) {
        notification {
          slug
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
      referralNotification_esMX: contentfulNotification(
        slug: { eq: "referral" }
        node_locale: { eq: "es-MX" }
      ) {
        slug
        description {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  `)

  const finalObject = {
    notificationBar: getDataByLocale(locale, data, 'notificationBar_'),
    referralNotification: getDataByLocale(
      locale,
      data,
      'referralNotification_',
    ),
  }
  return finalObject
}

export default useNotificationBarQuery
